import { Component, OnInit,ViewChild,ElementRef, inject, OnDestroy } from '@angular/core';
import { DropdownComponent } from 'src/app/common/components/core/dropdown/dropdown.component';
import { DropdownItem } from 'src/app/common/interfaces/dropdown-item.interface';
import { BiToolService } from 'src/app/common/services/bi-tool/bi-tool.service';
import { SecurityFeatureUtility } from 'src/app/common/services/security-feature.utility';
import { Features } from "src/app/common/enums/features.enum";
import { EmbeddedDashboard } from '@preset-sdk/embedded';
import { CommonModule } from '@angular/common';
import { BiDashboardConstants } from "src/app/common/constants/bi-dashboard.constants";
import { BiDashboardData } from 'src/app/common/interfaces/Bi-Dashboard/bi-dashboard.interface';
import { StorageService } from 'src/app/common/services/storage.service';
@Component({
  selector: "app-bi-dashboard",
  standalone: true,
  templateUrl: "./bi-dashboard.component.html",
  styleUrls: ["./bi-dashboard.component.scss"],
  imports: [DropdownComponent, CommonModule],
})
export class BiDashboardComponent implements OnInit, OnDestroy {
  private _biToolService = inject(BiToolService);
  private _securityFeatureUtility = inject(SecurityFeatureUtility);
  private _storageService = inject(StorageService);
  private _embeddedDashboardInstance?: EmbeddedDashboard;

  @ViewChild("biDashboardMountPoint") mountPoint!: ElementRef;
  categoryOptions: DropdownItem[] = [];
  dashboardOptions: DropdownItem[] = [];
  isCategorySelected: boolean = false;
  disableDashboard: boolean = true;
  dashboardAutoSelectByDefault: boolean = false;
  biDashboardConstants = BiDashboardConstants;
  selectedCategory: string | null = null;
  selectedDashboard : number | null = null;
  ngOnInit() {
    this._securityFeatureUtility.getSecurityFeature(Features.DASHBOARD);
    this._biToolService.syncPresetDashboards().subscribe();
    this._biToolService
      .getCategories()
      .subscribe(
        (res) => {
          this.categoryOptions = res.map((item) => ({
            id: item.value.toString(),
            name: item.display,
          }))
          this.getDefaultData();
        }
      );
  }

  ngOnDestroy() {
    if (!!this._embeddedDashboardInstance) {
      this._embeddedDashboardInstance.unmount();
    }
  }

  onCategoryChange(event: any) {
    if (!!this._embeddedDashboardInstance) {
      this._embeddedDashboardInstance.unmount();
    }
    this.disableDashboard = true;
    this.selectedCategory = event.value;
    this.selectedDashboard = null;
    this.setDefaultData();
    this.getDashboardOptions(event.value);    
  }

  getDashboardOptions(category: any){
    this._biToolService.getDashboards(category).subscribe((res) => {
      this.dashboardOptions = res.map((item) => ({
        id: item.value.toString(),
        name: item.display,
      }));
      this.disableDashboard = !this.dashboardOptions.length;
      this.isCategorySelected = true;
      this.dashboardAutoSelectByDefault = false;
      this.showDashboard();
    });
  }

  onDashboardChange(event: any) {
    if (!!this._embeddedDashboardInstance) {
      this._embeddedDashboardInstance.unmount();
    }
    this.selectedDashboard = parseInt(event.value);
    this.setDefaultData();
    this.showDashboard();
  }

  showDashboard(){
    if(this.selectedDashboard)
    this._biToolService
    .embedDashboard(this.selectedDashboard, this.mountPoint.nativeElement)
    .then((dashboard) => {
      if (!!dashboard) {
        this._embeddedDashboardInstance = dashboard;
      }
    });
  }

  private getDefaultData(){
    let data = this._storageService.getBiDashboard();
    if(!!data){
      this.selectedCategory = data.tag;
      this.selectedDashboard = data.dashboardId;
      this.getDashboardOptions(this.selectedCategory);
    }
  }

  private setDefaultData(){
    if(!!this.selectedDashboard || !!this.selectedCategory){
      let data : BiDashboardData = {
        tag : this.selectedCategory!,
        dashboardId : this.selectedDashboard
      }
      this._storageService.setBiDashboard(data);
    }
  }
}
